import {
    getOriented,
    triageMyInbox,
    findQuickWins,
    needsUrgentReplies,
    showTopActionItems,
    latestOnTopic,
    whatToGetToFirst,
    showMyTopThreeEmails,
    inboxMorningBriefing,
    inboxEveningBriefing,
    generateProactiveDrafts,
    type Suggestions,
} from '../utils/suggestionCatalog';
import { isUserCommercialPremium } from './isUserCommercialPremium';
import { isGlobalFeatureEnabled, isAccountFeatureEnabled } from 'owa-feature-flags';
import { shouldShowInboxBriefingsSUA } from 'owa-mail-inbox-briefings-utils/lib/utils/shouldShowInboxBriefingsSUA';
import { isMorningBriefing } from 'owa-mail-inbox-briefings-utils/lib/utils/currentTimeCheckUtils';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Helper function to navigate the A/B/C/D experiment structure for empty reading pane suggestions.
 * Three strings are being tested, split into three flights.
 * Flight name structure is: copilot-dab-mail-empty-rp-sua-treatment-A, -B, -C
 *
 * Note that the first two suggestions are always static, with only the third suggestion changing based on flight.
 */
export function getEmptyReadingPaneSuggestions(mailboxInfo: MailboxInfo): Suggestions {
    let baseSuggestions: Suggestions;

    // Non-Commercial Premium users are excluded from the SUA reading pane experiment,
    // just return original set of three suggestions
    if (!isUserCommercialPremium(mailboxInfo)) {
        baseSuggestions = [triageMyInbox, getOriented, findQuickWins];
    } else if (isGlobalFeatureEnabled('copilot-dab-mail-empty-rp-sua-treatment-A')) {
        baseSuggestions = [showTopActionItems, latestOnTopic, needsUrgentReplies];
    } else if (isGlobalFeatureEnabled('copilot-dab-mail-empty-rp-sua-treatment-B')) {
        baseSuggestions = [showTopActionItems, latestOnTopic, whatToGetToFirst];
    } else if (isGlobalFeatureEnabled('copilot-dab-mail-empty-rp-sua-treatment-C')) {
        baseSuggestions = [showTopActionItems, latestOnTopic, showMyTopThreeEmails];
    } else {
        // User not in experiment (e.g. control flight), return original set of three suggestions
        baseSuggestions = [triageMyInbox, getOriented, findQuickWins];
    }

    if (shouldShowInboxBriefingsSUA()) {
        // Add inbox briefing as 1st suggestion and remove the last item to keep the number of suggestions at 3
        baseSuggestions.unshift(isMorningBriefing() ? inboxMorningBriefing : inboxEveningBriefing);
        baseSuggestions.pop();
    }

    // Add "Generate Proactive Drafts" suggestion if the experimental flag is enabled
    // NOTE: this is temporary, throwaway code, to be removed at a later date when the experiment is done
    if (isAccountFeatureEnabled('mon-copilot-proactive-drafts-experimental', mailboxInfo)) {
        // Append as the 4th suggestion instead of replacing an existing one
        baseSuggestions.push(generateProactiveDrafts);
    }

    return baseSuggestions;
}
